import { IOcpiRegistration } from '../@types/ocpi';
import { apiConfig } from 'config';
import { WrapperService } from './wrapper';
// utils
// ----------------------------------------------------------------------

export class EMSPService {
  private apiService: WrapperService = new WrapperService();

  private baseURL = apiConfig.ocpi;

  getEMSPList(cpoId: string | undefined, offset = 0, limit = 10) {
    const apiParam = {
      method: 'GET',
      url: `/internal/ocpiprovider/cpo/${cpoId}/emsp?offset=${offset}&limit=${limit}`,
      baseURL: this.baseURL
    };
    return this.apiService.httpCall(apiParam);
  }

  getEMSPById(id: string) {
    const apiParam = {
      method: 'GET',
      url: `/internal/ocpiprovider/${id}`,
      baseURL: this.baseURL
    };
    return this.apiService.httpCall(apiParam);
  }

  saveEMSP = (ocpiProvider: IOcpiRegistration) => {
    ocpiProvider.versions = [];
    ocpiProvider.version_details = [];
    const apiParam = {
      method: ocpiProvider.id ? 'PUT' : 'POST',
      url: `/internal/ocpiprovider`,
      baseURL: this.baseURL,
      body: { ...ocpiProvider }
    };
    return this.apiService.httpCall(apiParam);
  };

  associateEMSPWithCPO = (cpoId: string, emspId: string) => {
    const apiParam = {
      method: 'PATCH',
      url: `/internal/ocpiprovider/${cpoId}/${emspId}`,
      baseURL: this.baseURL
    };
    return this.apiService.httpCall(apiParam);
  };
}
